
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.75 11.25A3.755 3.755 0 0015.5 7.5a3.755 3.755 0 00-3.75-3.75A3.755 3.755 0 008 7.5a3.755 3.755 0 003.75 3.75zm0-5.625c1.034 0 1.875.841 1.875 1.875a1.877 1.877 0 01-1.875 1.875A1.877 1.877 0 019.875 7.5c0-1.034.841-1.875 1.875-1.875z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.75 15c4.449 0 8.609-2.63 11.126-7.035a.936.936 0 000-.93C20.36 2.63 16.2 0 11.75 0S3.141 2.63.624 7.035a.936.936 0 000 .93C3.14 12.37 7.3 15 11.75 15zm9.221-7.5c-2.197 3.533-5.608 5.625-9.221 5.625-3.613 0-7.024-2.092-9.221-5.625 2.197-3.533 5.608-5.625 9.221-5.625 3.613 0 7.024 2.092 9.221 5.625z","fill":"#fff"}})])
          )
        }
      }
    